import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IRegieSimulationInputs, IRegieSimulationResults } from "../../interface/regie";

export const simulateRegie = async (
  inputs: IRegieSimulationInputs,
  token: string,
  setResults: (results: IRegieSimulationResults) => void,
  dispatch: Function,
  setError: Function
) => {
  try {
    const response = await axios.post(`${urlAPI}/regie/simulate`, inputs, {
      headers: { Authorization: `Bearer ${token}` },
    });
    setResults(response.data.message);
  } catch (error: any) {
    console.error(error);
    setError("Impossible de calculer la simulation.");
    dispatch(showSnackbar("Erreur lors du calcul de la simulation.", "error"));
  }
};
